var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHandshake(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.091,
    height: 33.067,
    viewBox: "0 0 55.091 33.067",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-handshake",
    "data-name": "Icon awesome-handshake",
    d: "M37.419,4.5H30.025a2.753,2.753,0,0,0-1.859.723L19.7,12.97c-.009.009-.017.026-.026.034a3.424,3.424,0,0,0-.181,4.82,3.59,3.59,0,0,0,4.829.232c.009-.009.026-.009.034-.017l6.878-6.3A1.377,1.377,0,1,1,33.1,13.771l-2.247,2.057L43.384,26a6.2,6.2,0,0,1,.68.663V10.009l-4.7-4.7A2.735,2.735,0,0,0,37.419,4.5Zm9.409,5.526V29.3a2.752,2.752,0,0,0,2.755,2.755h5.509V10.026ZM50.959,29.3a1.377,1.377,0,1,1,1.377-1.377A1.381,1.381,0,0,1,50.959,29.3ZM0,32.046H5.509a2.752,2.752,0,0,0,2.755-2.755V10.026H0Zm4.132-5.5a1.377,1.377,0,1,1-1.377,1.377A1.381,1.381,0,0,1,4.132,26.545Zm37.522,1.6L28.8,17.713,26.22,20.08a6.2,6.2,0,0,1-8.376-9.133L24.886,4.5H17.672a2.75,2.75,0,0,0-1.945.809l-4.709,4.7V29.282h1.575l7.79,7.05a5.508,5.508,0,0,0,7.747-.8l.017-.017,1.541,1.334a3.2,3.2,0,0,0,4.5-.465l2.7-3.323.465.379a2.75,2.75,0,0,0,3.874-.4l.818-1.007a2.76,2.76,0,0,0-.4-3.882Z",
    transform: "translate(0 -4.5)",
    fill: "#3d3d3d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandshake);
export default __webpack_public_path__ + "static/media/handshake.665a60d2cfec77d527ea07d0153d3ada.svg";
export { ForwardRef as ReactComponent };